// Copyright © 2019 Mapotempo

import '../../assets/javascripts/prototype_extension'
